import { isMobilePhone, isEmail, isIdentityCard } from 'validator'

export const bidderMobilePhonePass = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('该项为必填项目'))
  }
  if (!isMobilePhone('' + value, 'zh-CN')) {
    return callback(new Error('请输入正确的手机号码'))
  }
  callback()
}

export const identityCardPass = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('该项为必填项目'))
  }
  if (!isIdentityCard('' + value, 'zh-CN')) {
    return callback(new Error('请填写正确的法人身份证号码'))
  }
  callback()
}

export const bidderLinkMailPass = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('该项为必填项目'))
  }
  if (!isEmail('' + value)) {
    return callback(new Error('请输入正确的邮箱'))
  }
  callback()
}

export const bidderTaxID = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('该项为必填项目'))
  }
  if (value.length > 20 || value.length < 15) {
    return callback(new Error('请输入正确的纳税人识别码'))
  }
  callback()
}

export const bidderBank = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('该项为必填项目'))
  }
  if (!/^\d{19}$/.test(value)) {
    return callback(new Error('请输入正确的银行卡号'))
  }
  callback()
}
